import { Lock, ArrowLeft, ShieldAlert } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

interface Props {
  heldByName: string | null;
  heldAt: string | null;
  onBack: () => void;
  onForceRelease?: () => void;
}

export default function LockedProjectModal({ heldByName, heldAt, onBack, onForceRelease }: Props) {
  const isOwner = useAuthStore((s) => s.isPlatformOwner());
  const when = heldAt ? new Date(heldAt) : null;
  const minutesAgo = when ? Math.max(1, Math.round((Date.now() - when.getTime()) / 60000)) : null;

  return (
    <div className="fixed inset-0 z-[200] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#151518] border border-white/[0.08] rounded-xl shadow-2xl p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-amber-500/15 flex items-center justify-center">
            <Lock size={18} className="text-amber-400" />
          </div>
          <div>
            <h2 className="text-sm font-semibold text-zinc-100">Project is being edited</h2>
            <p className="text-[11px] text-zinc-500 mt-0.5">
              Ask them to click Release, or try again in a couple of minutes.
            </p>
          </div>
        </div>

        <div className="p-3 rounded-lg bg-white/[0.03] border border-white/[0.04] text-xs text-zinc-300">
          <div>
            <span className="text-zinc-500">Currently held by:</span>{' '}
            <span className="font-medium">{heldByName || 'another user'}</span>
          </div>
          {minutesAgo !== null && (
            <div className="mt-1">
              <span className="text-zinc-500">Last activity:</span>{' '}
              <span className="font-medium">{minutesAgo} minute{minutesAgo === 1 ? '' : 's'} ago</span>
            </div>
          )}
        </div>

        <div className="flex gap-2">
          <button
            onClick={onBack}
            className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-white/[0.04] hover:bg-white/[0.08] text-zinc-200 text-xs font-medium"
          >
            <ArrowLeft size={13} /> Back to projects
          </button>
          {isOwner && onForceRelease && (
            <button
              onClick={onForceRelease}
              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-red-500/15 hover:bg-red-500/25 text-red-300 text-xs font-medium"
              title="Force release this lock (platform owner)"
            >
              <ShieldAlert size={13} /> Force override
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
